import React, { useState, useEffect } from 'react';
import {
  MDBContainer,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBBtn,
  MDBInput,
  MDBCheckbox,
}
from 'mdb-react-ui-kit';
import { Alert, Badge } from 'react-bootstrap';
import axios from 'axios';
import GoogleSignIn from './GoogleSignIn';
import { useToast } from "@chakra-ui/react";
import { API_BASE_URL } from './config/api_keys';


function Login({ initialActiveTab }) {
  const [err, setErr] = useState();
  const [justifyActive, setJustifyActive] = useState(initialActiveTab || 'tab1');
  const toast = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  // Update the active tab if initialActiveTab changes
  useEffect(() => {
    if (initialActiveTab) {
      setJustifyActive(initialActiveTab);
    }
  }, [initialActiveTab]);

  const handleJustifyClick = (value) => {
    if (value === justifyActive) {
      return;
    }

    setJustifyActive(value);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value
    });
  };

  const [registered, setRegistered] = useState(false);
  function register(event){
      event.preventDefault();
      setErr(null);
      setIsLoading(true);
      document.getElementById("alert").innerHTML = '';
      
      const { name, email, password, confirmPassword } = formData;
      
      if (password !== confirmPassword){
        document.getElementById("alert").innerHTML = `Passwords Don't Match`;
        setIsLoading(false);
        return;
      }
      
      axios
      .post(`${API_BASE_URL}/register`, {
          email: email,
          password: password,
          name: name,
      })
      .then((response) => {
        console.log(response.data);
        setRegistered(true);
        
        toast({
          title: 'Account created.',
          description: "We've created your account for you. Logging you in...",
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        
        // Automatically log in the user after successful registration
        axios
        .post(`${API_BASE_URL}/login`, {
            email: email,
            password: password
        })
        .then((loginResponse) => {
          console.log(loginResponse.data);
          localStorage.setItem('authToken', loginResponse.data.token);
          localStorage.setItem('authemail', loginResponse.data.email);
          localStorage.setItem('authname', loginResponse.data.name);
          localStorage.setItem('authphone', loginResponse.data.phone);
          localStorage.setItem('authpicture', loginResponse.data.picture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png");
          localStorage.setItem('userId', loginResponse.data.userId);
          
          // Redirect to home page after login
          setTimeout(() => {
            window.location.href = '/';
          }, 1000);
        })
        .catch((loginError) => {
          console.error("Auto-login failed:", loginError);
          setIsLoading(false);
          // If auto-login fails, just switch to login tab
          setJustifyActive('tab1');
        });
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        if (error.response && error.response.status) {
          setErr(error.response.status);
        } else {
          // Handle network errors or other issues
          toast({
            title: 'Registration failed',
            description: "There was an error creating your account. Please try again.",
            status: 'error',
            duration: 9000,
            isClosable: true,
          });
        }
      });
  }

  function login(event){
      event.preventDefault();
      setIsLoading(true);
      var email = document.getElementById("email").value;
      var password = document.getElementById("password").value;
      axios
      .post(`${API_BASE_URL}/login`, {
          email,password
      })
      .then((response) => {
        console.log(response.data);
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('authemail', response.data.email);
        localStorage.setItem('authname', response.data.name);
        localStorage.setItem('authphone', response.data.phone);
        localStorage.setItem('authpicture', response.data.picture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png");
        localStorage.setItem('userId', response.data.userId); // Store userId
        window.location.href = '/';
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error.response.status);
        setErr(error.response.status)
      });
  }
  return (
    <MDBContainer className="p-3 mt-1 mb-1 my-5 d-flex flex-column">
      <MDBTabs pills justify className='mb-3 d-flex flex-row justify-content-between'>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab1')} active={justifyActive === 'tab1'}>
            Login
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab2')} active={justifyActive === 'tab2'}>
            Register
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>

      <MDBTabsContent >

        <MDBTabsPane show={justifyActive === 'tab1'}>
     

          <div className="text-center mb-3">
            <p>Sign in with:</p>

            <div>
              <GoogleSignIn />
            </div>

            <p className="text-center mt-3">or:</p>
          </div>



          <form onSubmit={login}>
          <div className="mb-4">
                <MDBInput label='Your Email' id='email' type='email' required/>
              </div>

              <div className="mb-4">
                <MDBInput label='Password' id='password' type='password' required/>
              </div>

          <div className="d-flex justify-content-between mx-4 mb-4">
            <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Remember me' />
            <a href="!#">Forgot password?</a>
          </div>

          <MDBBtn className="mb-4 w-100" type="submit" disabled={isLoading}>
            {isLoading ? 'Signing in...' : 'Sign in'}
          </MDBBtn>
          </form>
          {err === 404 && <Alert variant='danger'> Incorrect Email</Alert>}
          {err === 400 && <Alert variant='danger'> Incorrect Password</Alert>}
          <p className="text-center">Not a member? <a href='#' onClick={() => handleJustifyClick('tab2')} active={justifyActive === 'tab2'}>Register</a></p>

        </MDBTabsPane>

        <MDBTabsPane show={justifyActive === 'tab2'}>

          <div className="text-center mb-3">
            <p>Sign up with:</p>

            <div>
              <GoogleSignIn />
            </div>

            <p className="text-center mt-3">or:</p>
          </div>

          
          {registered === false &&
          <form onSubmit={register}>
          <MDBInput 
            wrapperClass='mb-4' 
            label='Name' 
            id='name' 
            type='text' 
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          <MDBInput 
            wrapperClass='mb-4' 
            label='Email' 
            id='email' 
            type='email'
            value={formData.email}
            onChange={handleInputChange} 
            required
          />
          <MDBInput 
            wrapperClass='mb-4' 
            label='Password' 
            id='password' 
            type='password'
            value={formData.password}
            onChange={handleInputChange} 
            required
          />
          <MDBInput 
            wrapperClass='mb-4' 
            label='Repeat your password' 
            id='confirmPassword' 
            type='password'
            value={formData.confirmPassword}
            onChange={handleInputChange} 
            required
          />

          <Badge id="alert" className="mb-1" bg="danger"></Badge>

          <div className='d-flex justify-content-center mb-4'>
            <MDBCheckbox name='flexCheck' id='flexCheckDefault' label='I have read and agree to the terms' required/>
          </div>
          {err === 409 && <Alert variant='danger'>User Already Exists, Please Login</Alert>}
          <MDBBtn className="mb-4 w-100" type='submit' disabled={isLoading}>
            {isLoading ? 'Creating account...' : 'Sign up'}
          </MDBBtn>
          </form>
}
          {registered === true && <Alert variant='success'> Registration successful! Logging you in...</Alert>}

        </MDBTabsPane>

      </MDBTabsContent>

    </MDBContainer>
  );
}

export default Login;
